/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Expense_Rule_Keyword_EmptyInputs */

const vi_error_expense_rule_keyword_empty = /** @type {(inputs: Error_Expense_Rule_Keyword_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ khoá phải có ít nhất một chữ hoặc số.`)
};

/**

* @param {Error_Expense_Rule_Keyword_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_expense_rule_keyword_empty = /** @type {((inputs?: Error_Expense_Rule_Keyword_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Expense_Rule_Keyword_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_expense_rule_keyword_empty(inputs)
});